import { render } from "./TicketCategoryView.vue?vue&type=template&id=04a41217&scoped=true"
import script from "./TicketCategoryView.vue?vue&type=script&lang=js"
export * from "./TicketCategoryView.vue?vue&type=script&lang=js"

import "./TicketCategoryView.vue?vue&type=style&index=0&id=04a41217&scoped=true&lang=css"
import "./TicketCategoryView.vue?vue&type=style&index=1&id=04a41217&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a41217"]])

export default __exports__